import 'brace/ext/language_tools';
import 'brace/ext/searchbox';
import 'brace/mode/python';
import 'brace/mode/sql';
import React from 'react';
import AceEditor from 'react-ace';

import {PYTHON_STARTER_CODE} from './StarterCode';

export type CodeEditorMode = 'python' | 'sql';

const DEFAULT_VALUE: Record<CodeEditorMode, string> = {
  python: PYTHON_STARTER_CODE,
  sql: '',
};

interface UserDefinedFunctionEditorProps {
  config: string | null;
  onChangeConfig: (config: string | null) => void;
  disabled?: boolean;
  mode?: CodeEditorMode;
}

export default function UserDefinedFunctionEditor({
  config,
  onChangeConfig,
  disabled,
  mode = 'python',
}: UserDefinedFunctionEditorProps): JSX.Element {
  return (
    <AceEditor
      value={config ?? DEFAULT_VALUE[mode]}
      onChange={onChangeConfig}
      mode={mode}
      readOnly={disabled}
      showGutter={true}
      showPrintMargin={false}
      minLines={20}
      wrapEnabled={true}
      // TODO(BNCH-123236): Make height and width responsive
      width="500px"
      height="600px"
    />
  );
}
